import { ReactNode } from 'react';
import { useLogger } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { ApiError } from '@packages/shared/core/common/errors';
import {
  EmailFormHelpers,
  EmailModalFormHelpers,
  EmailStepData,
  QuizScreenProps,
} from '@packages/shared/core/quiz/entities';

type EmailQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const EmailQuizStep = ({ id, renderQuizScreen }: EmailQuizStepProps) => {
  const logger = useLogger();
  const { back, next, stepData, userPreferences, signUpUser, totalSteps } = useQuizStep(id);

  if (!stepData) {
    // TODO add fallback
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const { dataKey } = stepData as EmailStepData;

  const goBack = async () => back();

  const initialValue = typeof userPreferences[dataKey] === 'string' ? (userPreferences[dataKey] as string) : '';

  const handleSubmit = async (
    data: { email: string; emailConsent?: boolean },
    { setErrors }: EmailFormHelpers | EmailModalFormHelpers,
  ) => {
    try {
      await signUpUser(data);
    } catch (err) {
      if (err instanceof ApiError) {
        setErrors({ email: err.originalError.message });
      } else {
        setErrors({ email: 'Something went wrong. Try again later' });
      }
      return;
    }

    await next();
  };

  return (
    <>
      {renderQuizScreen({
        onBack: goBack,
        initialValue,
        onSubmit: handleSubmit,
        totalSteps,
        ...(stepData as EmailStepData),
      })}
    </>
  );
};

export default EmailQuizStep;
